import { Reducer } from "redux";
import { Action, ActionType } from "../actionTypes/pidfActionType";

export interface IPidfState {
  PidfData: any[];
}

const initialState = {
  PidfData: [],
};

export const PidfReducer: Reducer<IPidfState, Action> = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.PIDF_LIST:
      return {
        ...state,
        PidfData: action.payload,
      };
    default:
      return state;
  }
};
